import { UrlObject } from 'url';
import Button, { ButtonProps as MUIButtonProps } from '@mui/material/Button';
import * as Sentry from '@sentry/nextjs';
import { useRouter } from 'next/router';
import React, { ReactNode } from 'react';
import useLogger from '~/hooks/useLogger';
export interface ILinkButtonProps extends Omit<MUIButtonProps, 'href'> {
  children: ReactNode;
  href: string | UrlObject;
  onClick?: () => void;
}
export const LinkButton: React.FC<ILinkButtonProps> = ({
  children,
  href,
  onClick,
  ...buttonProps
}) => {
  const router = useRouter();
  const logger = useLogger('LinkButton');
  const handleOnClick = async (): Promise<void> => {
    onClick?.();
    try {
      await router.push(href);
    } catch (err) {
      Sentry.captureException(err);
      logger.error(err);
    }
  };
  return <Button onClick={handleOnClick} {...buttonProps} data-sentry-element="Button" data-sentry-component="LinkButton" data-sentry-source-file="index.tsx">
      {children}
    </Button>;
};
export default LinkButton;